__turbopack_context__.v({
  "fadeInDown": "FadeIn-module-scss-module__HHwf3a__fadeInDown",
  "standard": "FadeIn-module-scss-module__HHwf3a__standard",
  "top": "FadeIn-module-scss-module__HHwf3a__top",
});
